var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"slot":"fixed","headerMenu":true,"headerBack":true},slot:"fixed"}),_c('ion-content',[_vm._v(" LetterUpdate ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }